import z from 'zod';
import {contactMessageDbSchema} from './contactMessageDbSchema';

/** Document shape as stored in DB (id comes from Firestore document id when reading). */
export const contactMessageSchema = contactMessageDbSchema.extend({
  id: z.string(),
});

export interface ContactMessage extends z.infer<typeof contactMessageSchema> {}
